/* =================================================================
   Traditional Zürich — Central Config + Consent Manager

   ARCHITECTURE: Shopify-first. n8n ist OPTIONAL (Mai 2026 out-of-order
   wegen Workflow-Limit). Frontend funktioniert vollständig OHNE n8n:
   - Cart/Checkout/Login → direkt Shopify
   - Newsletter/Freebie → fail-safe, loggt Payload wenn webhook leer
   - Advisor → läuft lokal, Empfehlung ohne Webhook anzeigbar
   - Tracking → Meta/GA4/GTM direkt im Theme oder über diese Config-IDs
   - n8n → wird Phase 2 aktiviert, sobald wieder Workflow-Kapazität da

   REGEL: alle Webhook-Calls sind fail-safe. Leere URL = kein Fehler,
   keine User-blockierende Aktion. Shopify bleibt System of Record.

   Load this BEFORE any other tzh script.
   ================================================================= */
(function(){
'use strict';

// --- Defaults (overridden by inline-script if values are provided) ---
const DEFAULT_CONFIG = {
  environment: 'staging',
  project: 'TZ Traditional Zurich',
  brand: 'Traditional Zurich',
  useExistingN8nWorkflow: false,   // ← n8n optional / aktuell out-of-order
  doNotTouchProjects: ['Aveda'],

  // --- Tracking IDs (leave empty → tracking gracefully disabled)
  //     Setze diese direkt im Shopify Theme oder per Deployment-ENV.
  metaPixelId: '',
  ga4MeasurementId: '',
  googleTagManagerId: '',

  // --- n8n endpoints — OPTIONAL ---
  //     n8n ist aktuell wegen Workflow-Limit nicht verfügbar.
  //     Leere URL → Payload wird console-logged, KEIN User-Fehler.
  //     Live-Funktion (Cart/Checkout) hängt NICHT von n8n ab.
  //     Phase-2: wenn n8n wieder läuft, hier URLs eintragen, fertig.
  n8nBaseUrl: '',
  webhookLead: '',
  webhookAdvisor: '',
  webhookCart: '',            // unused — Cart läuft direkt über Shopify
  webhookBooking: '',
  webhookNewsletter: '',
  webhookAnalytics: '',
  webhookFreebie: '',
  webhookContact: '',

  // --- Brand contact ---
  whatsappNumber: '41438176870',
  shopifyDomain: 'traditional-zuerich.ch',
  bookingUrl: '',

  // --- Consent ---
  consentRequired: true,
  consentVersion: 'v1.0-2026',

  // --- Feature flags ---
  debug: false,
  enableMockup: true
};

// Merge user-provided config (set BEFORE this script via inline)
window.TZH_CONFIG = Object.assign({}, DEFAULT_CONFIG, window.TZH_CONFIG || {});

// --- Consent state (essential always on, marketing requires opt-in) ---
const CONSENT_KEY = 'tzh_consent_v1';
function readConsent(){
  try { return JSON.parse(localStorage.getItem(CONSENT_KEY) || 'null'); }
  catch { return null; }
}
function writeConsent(state){
  try { localStorage.setItem(CONSENT_KEY, JSON.stringify(Object.assign({ ts: Date.now(), version: window.TZH_CONFIG.consentVersion }, state))); } catch {}
}

window.TZHConsent = {
  required: window.TZH_CONFIG.consentRequired,
  get: () => {
    const c = readConsent();
    if(!c) return { marketing:false, statistics:false, essential:true, decided:false };
    return Object.assign({ marketing:false, statistics:false, essential:true, decided:true }, c);
  },
  set: (state) => {
    const merged = Object.assign({ marketing:false, statistics:false, essential:true }, state);
    writeConsent(merged);
    document.dispatchEvent(new CustomEvent('tzh:consent-changed', { detail: merged }));
    return merged;
  },
  acceptAll: () => window.TZHConsent.set({ marketing:true, statistics:true, essential:true }),
  acceptEssential: () => window.TZHConsent.set({ marketing:false, statistics:false, essential:true }),
  reset: () => { try { localStorage.removeItem(CONSENT_KEY); } catch {}; document.dispatchEvent(new CustomEvent('tzh:consent-reset')); },
  needsBanner: () => window.TZH_CONFIG.consentRequired && !readConsent()
};

// --- Session helper (anonymous session id) ---
const SESSION_KEY = 'tzh_session_v1';
function getSessionId(){
  try {
    let s = sessionStorage.getItem(SESSION_KEY);
    if(!s){
      s = 'ses_'+Date.now().toString(36)+'_'+Math.random().toString(36).slice(2,10);
      sessionStorage.setItem(SESSION_KEY, s);
    }
    return s;
  } catch { return 'ses_'+Date.now().toString(36); }
}
window.TZHSession = { id: getSessionId };

// --- Webhook dispatcher (fail-safe, beacon-first) ---
window.TZHWebhook = {
  post: function(url, payload){
    if(!url){
      if(window.TZH_CONFIG.debug) console.log('[TZHWebhook] No URL configured. Payload:', payload);
      return Promise.resolve({ ok:false, reason:'no_url' });
    }
    try {
      if(navigator.sendBeacon){
        const ok = navigator.sendBeacon(url, new Blob([JSON.stringify(payload)], {type:'application/json'}));
        return Promise.resolve({ ok });
      }
      return fetch(url, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload), keepalive:true })
        .then(r => ({ ok: r.ok })).catch(e => ({ ok:false, error:String(e) }));
    } catch(e){
      console.warn('[TZHWebhook] failed', e);
      return Promise.resolve({ ok:false, error:String(e) });
    }
  }
};

// --- Payload builder (canonical schema) ---
window.TZHPayload = {
  build: function(event, data){
    const consent = window.TZHConsent.get();
    return Object.assign({
      source: 'website',
      project: window.TZH_CONFIG.project,
      brand: window.TZH_CONFIG.brand,
      environment: window.TZH_CONFIG.environment,
      event: event,
      timestamp: new Date().toISOString(),
      page: window.location.pathname,
      url: window.location.href,
      referrer: document.referrer || null,
      sessionId: window.TZHSession.id(),
      consent: { marketing: consent.marketing, statistics: consent.statistics, essential: true, version: window.TZH_CONFIG.consentVersion },
      utm: (function(){ const p=new URLSearchParams(location.search); const o={}; ['utm_source','utm_medium','utm_campaign','utm_term','utm_content'].forEach(k=>{const v=p.get(k); if(v) o[k]=v;}); return o; })()
    }, data || {});
  }
};

if(window.TZH_CONFIG.debug) console.log('[TZH] Config loaded:', window.TZH_CONFIG);
})();
